export default {
  home: {
    minute: 'minuto',
    price_info: 'Gratuito per i primi {mianfei} min. Massimo {currencyName}{fengding} al giorno. La cauzione verrà detratta automaticamente quando il noleggio raggiunge {currencyName}{yajin}',
    feature_1: 'Adatto a tutti i tipi di telefoni cellulari',
    feature_2: 'Può essere restituito in qualsiasi altra stazione',
    feature_3: 'Design speciale - ricarica wireless (solo per i moduli supportati)',
    tips_1: 'La tua cauzione di {currencyName}{yajin} ti verrà rimborsata dopo la restituzione del power bank.',
    yajin_info: 'Massimo {currencyName}{fengding} al giorno',
    tips_2: 'La cauzione {currencyName}{yajin} può essere noleggiata, utilizzata e poi rimborsata',
    tips_3: 'Il saldo attuale è {currencyName}{myyue}, può essere noleggiato direttamente',
    submit: 'Ricarica',
    borrow: 'Noleggia',
    msg_fail_title: 'Errore',
    msg_fail_content: 'Noleggio fallito, riprova',
    msg_rentcount: 'Hai {zujieNum} ordini non chiusi',
    goborrow: 'Vai a caricare!!!',
    nearby: 'Vedi i punti nelle vicinanze',
    preauth: 'Pre-autorizzazione',
    shopTime: 'Orari di apertura',
    分钟: 'minuto',
    小时: 'ora',
    天: 'giorno'
  },
  button: {
    添加新卡: 'Aggiungi nuova carta',
    delete_card: 'Elimina carta',
    Delete: 'Elimina'
  },
  selectpackage: {
    powerbank: 'Power Bank',
    powerstation: 'Stazione di alimentazione',
    wifibox: 'WiFi Box',
    choosepackage: 'Scegli un pacchetto',
    minute: 'minuto',
    首次免费: 'Gratuito per i primi ',
    最大每日收费: 'Massimo addebitato al giorno: ',
    devicedeposit: 'Cauzione apparecchio',
    return_will_back: 'La cauzione viene restituita dopo la restituzione dell\'apparecchio',
    lengthofuse: 'Durata d\'uso',
    amountcharged: 'Importo accumulato',
    release_powerbank: 'Rilascia il power bank',
    see_pricing: 'Vedi i prezzi',
    deposit: 'cauzione',
    agreen: 'Continuando, accetti i nostri ',
    privacy_policy: 'Informativa sulla privacy',
    and: ' e ',
    terms_and_conditions: 'Termini e condizioni.',
    per: 'per'
  },
  wifimall: {
    Select: 'Seleziona',
    subtitle: 'Pacchetti consigliati',
    dayuse: 'Giorni di utilizzo',
    Verify: 'Verifica',
    无限流量: 'Illimitato',
    天: 'giorno',
    days: 'giorni',
    useDay: 'Giorni di uso',
    mypackages: 'Seleziona un pacchetto esistente',
    没有更多了: 'Non ce ne sono altri',
    加载中: 'Caricamento',
    depositof: 'Include una cauzione di ',
    usagetime: 'Tempo di utilizzo'
  },
  paymethod: {
    payamount: 'Importo',
    choosepaymethod: 'Scegli metodo di pagamento',
    addcard: 'Aggiungi nuova carta',
    confrimpay: 'Conferma pagamento',
    借记卡: 'Carta di debito',
    银行卡列表: 'Elenco carte bancarie'
  },
  login: {
    title: 'Accedi o registrati',
    code_title: 'Verifica SMS',
    phone_number: 'Numero di telefono',
    verification_code: 'Inserisci il codice di verifica SMS. Se non ricevi il codice, prova un altro metodo di accesso.',
    captcha_code: 'Codice',
    send_code: 'Invia codice',
    login: 'Accedi',
    agree: 'Accedendo, accetti ',
    readme: 'Accordo utente',
    msg_fail_login: 'Accesso fallito',
    msg_success_login: 'Accesso riuscito',
    msg_fail_user: 'Errore nel recupero delle informazioni utente. Vuoi riprovare?',
    sign_in_with: 'Accedi con',
    no_sms: 'Non hai ricevuto il messaggio',
    retry: 'Rinvio',
    applelogin: 'Accedi con Apple',
    otherlogin: 'Altre opzioni',
    quicklogin: 'Accesso rapido',
    mobilelogin: 'Accesso mobile',
    emaillogin: 'Accesso email',
    facelogin: 'Accedi con Facebook'
  },
  confirm: {
    'Credit Card': 'Carta di credito',
    WeChat: 'WeChat',
    'Apple Pay': 'Apple Pay',
    'Google Pay': 'Google Pay',
    'SMS Payment': 'Pagamento SMS',
    'Idael Pay': 'Idael Pay',
    title: 'Conferma pagamento',
    savenow: 'Salva ora',
    confirmpay: 'Conferma pagamento',
    SMSConfirm: 'Effettua il pagamento secondo il messaggio ricevuto e clicca su conferma.',
    pay_label: 'Importo',
    auth_label: 'Pre-autorizzazione',
    price_tips: 'Il tuo saldo può essere prelevato su richiesta. Possono essere necessari 1-5 giorni lavorativi.',
    auth_tips: 'È obbligatorio un importo di pre-autorizzazione di {0}{1}. L\'importo effettivo del noleggio verrà detratto alla restituzione.',
    pay_type: 'Seleziona il metodo di pagamento preferito',
    submit: 'Conferma pagamento',
    msg_loading: 'Caricamento...',
    msg_fail_title: 'Avviso',
    msg_fail_payment: 'Pagamento cauzione fallito',
    msg_fail_order: 'Creazione ordine di noleggio fallita',
    msg_fail_support: 'Sistema non supportato',
    msg_fail_confirm: 'Conferma',
    msg_fail_retry: 'Riprova',
    msg_fail_cancel: 'Annulla',
    msg_none_msg: 'Inserisci altre informazioni per identificarti'
  },
  mine: {
    title: 'Profilo utente',
    wallet: 'Il mio portafoglio',
    balance: 'Il mio saldo',
    deposit: 'Cauzione',
    wallet_in: 'Ricarica',
    wallet_out: 'Preleva',
    wallet_log: 'Storico',
    order: 'Ordine',
    coupon: 'Coupon',
    login_tips: 'Effettua il login',
    msg_fail_title: 'Errore',
    msg_fail_update: 'Modifica fallita, riprova',
    msg_loading: 'Caricamento...',
    msg_fail_user: 'Errore nel recupero delle informazioni. Riprova?',
    help: 'Aiuto',
    setting: 'Impostazioni',
    logout: 'Disconnetti',
    buy: 'Acquista apparecchio',
    aboutus: 'Chi siamo',
    contactus: 'Contattaci'
  },
  msg: {
    no_phone: 'Il numero di telefono è obbligatorio',
    loading: 'Caricamento...',
    title: 'Suggerimento',
    success: 'Operazione riuscita',
    sendsuccess: 'Inviato con successo',
    error: 'Errore sconosciuto, riprova più tardi.',
    deletecard: 'Sei sicuro di voler eliminare questa carta?',
    confirm: 'Conferma',
    retry: 'Riprova',
    cancel: 'Annulla',
    title_fail: 'Avviso',
    vieworder: 'Vedi ordine',
    success_payment: 'Pagamento completato',
    success_buy: 'Acquisto completato',
    fail_payment: 'Pagamento fallito',
    keyword: 'parola chiave',
    nodata: 'Nessun dato',
    copysuccess: 'Copiato con successo',
    notopen: 'Non ancora aperto',
    devicenotactivated: 'Apparecchio non attivato',
    pickup_fail: 'Recupero apparecchio fallito. Riprova più tardi',
    msg_none_name: 'Inserisci il tuo nome',
    msg_none_email: 'Inserisci il tuo indirizzo email',
    msg_none_mobile: 'Inserisci il tuo numero di telefono',
    msg_none_nation: 'Inserisci il tuo paese',
    msg_none_msg: 'Inserisci altre informazioni per identificarti',
    msg_fail_choosepackage: 'Seleziona un punto di ritiro',
    geolocationfailed: 'Errore: il servizio di geolocalizzazione è fallito.'
  },
  result: {
    title: 'Conferma risultato',
    price_plan: 'Tariffa di ricarica',
    msg_success: 'Noleggiato con successo',
    msg_tips_loading: 'Il power bank sta uscendo, attendi...',
    msg_result_loading: 'Il risultato del pagamento è in fase di conferma...',
    msg_fail_confirm: 'Conferma',
    btn_usage: 'Istruzioni d\'uso',
    btn_return: 'Istruzioni di restituzione',
    deposit: 'Cauzione',
    msg_fail_content: 'Richiesta fallita, riprova',
    price_label: 'all\'ora',
    price_info: 'Gratuito per i primi {mianfei} min, massimo {ccurrency}{fengding} al giorno, la cauzione viene detratta automaticamente quando il noleggio raggiunge {ccurrency}{yajin}',
    tips_1: 'Ritira il power bank <span class="number">N. {number}</span> come mostrato',
    tips_2: 'Sistema i cavi e inserisci il power bank con la <span class="highlight">[freccia verso il basso]</span> per la restituzione',
    msg_note_usage: 'Il power bank ha 3 tipi di cavi e ricarica wireless, usali secondo le necessità.',
    msg_note_return: 'Sistema i cavi e inserisci il power bank con la [freccia verso il basso] per la restituzione.',
    return_info: 'Per la restituzione: sistema i cavi e inserisci il lato con i contatti metallici in una presa vuota fino in fondo.'
  },
  result_msg: {
    loading: 'Caricamento...',
    refresh: 'Aggiorna'
  },
  order: {
    title: 'Ordine di noleggio',
    in_use: 'In uso',
    ended: 'Terminato',
    enter_order_email: 'Inserisci l\'email',
    msg_error: 'Richiesta fallita'
  },
  order_item: {
    order_number: 'N.',
    venue_rented: 'Punto di ritiro',
    time_rented: 'Ora di ritiro',
    venue_returned: 'Punto di restituzione',
    time_returned: 'Ora di restituzione',
    charge_standard: 'Tariffa',
    charge_standard_info: '{pJifei} {pCurrency} all\'ora (primi {pMian} min gratuiti)',
    rent_occurred: 'Noleggio maturato',
    returned: 'Restituito',
    unreturned: 'Non restituito',
    type_0: 'Non completato',
    type_1: 'In noleggio',
    type_2: 'Annullato',
    type_3: 'Restituito',
    type_4: 'Guasto',
    type_5: 'In ritardo',
    min: 'Min',
    payment: 'Pagamento'
  },
  setting: {
    title: 'Impostazioni',
    lang: 'Lingua'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Ricarica saldo',
    price_label: 'Importo di ricarica',
    price_placeholder: 'Inserisci l\'importo di ricarica',
    balance: 'Saldo attuale',
    price_auto: 'Scegli l\'importo',
    price_tips: 'Il tuo saldo può essere prelevato su richiesta. Possono essere necessari 1-5 giorni lavorativi.',
    submit: 'Invia',
    loading: 'Caricamento...',
    paying: 'Reindirizzamento alla pagina di pagamento...',
    msg_title: 'Suggerimento',
    msg_fail_order: 'Creazione ordine fallita',
    msg_fail_payment: 'Avvio pagamento fallito',
    msg_fail_retry: 'Riprova',
    选择充值金额: 'Scegli l\'importo',
    输入充值金额: 'Inserisci l\'importo',
    确认充值: 'Conferma ricarica'
  },
  wallet_out: {
    title: 'Prelievo',
    price_label: 'Importo di prelievo',
    price_placeholder: 'Inserisci l\'importo di prelievo',
    balance: 'Saldo attuale',
    balance_all: 'Preleva tutto',
    deposit: 'Cauzione',
    deposit_tips: 'C\'è un ordine di noleggio. La cauzione di {pcurrencyName}{pyajin} non è rimborsabile',
    submit: 'Invia',
    apply: 'Applica',
    confirm: 'Conferma',
    loading: 'Caricamento...',
    msg_fail_price: 'L\'importo di prelievo non è corretto',
    msg_fail_balance: 'L\'importo non può superare il saldo attuale',
    msg_fail_submit: 'Compila tutte le informazioni',
    msg_title: 'Errore',
    msg_success_content: 'Rimborso richiesto con successo',
    confirmtitle: 'Suggerimento',
    confirmcontent: 'Il portafoglio attuale non supporta il prelievo di contanti. Contattaci per il rimborso manuale',
    payee_name: 'Nome del beneficiario',
    payee_bankcard: 'Numero carta',
    payee_phone: 'Telefono',
    cancelText: 'Annulla',
    confirmText: 'Riapplica',
    退款金额: 'Importo rimborso'
  },
  map: {
    title: 'Apparecchi nelle vicinanze',
    result_msg: 'Nessun apparecchio trovato nelle vicinanze',
    msg_title: 'errore',
    no_support: 'Spiacenti! Il tuo browser non supporta la geolocalizzazione',
    my_position: 'La mia posizione',
    distance: 'distanza:',
    shop_time: 'ore',
    free: 'noleggiabile',
    return: 'restituibile',
    shop_title: 'Dettagli del negozio',
    address: 'indirizzo',
    go_here: 'Vai qui'
  },
  scanOrder: {
    viewflowdetail: 'Vedi dettagli utilizzo',
    confirmpickup: 'Conferma ritiro',
    QRpickup: 'Ritiro QR code',
    取机中: 'Ritiro',
    scanQR: 'Scansiona QR code per associare',
    qrCodePickup: 'Ritiro QR code',
    orderNo: 'N. ordine',
    startingTime: 'Ora inizio',
    endTime: 'Ora fine',
    packageStatus: 'Stato pacchetto',
    无限流量: 'Illimitato',
    天: 'giorno',
    days: 'giorni',
    type_0: 'Non usato',
    type_1: 'Da attivare',
    type_2: 'Attivato',
    type_3: 'Revocato',
    type_4: 'Rimborsato',
    type_9: 'Scaduto',
    type_33: 'Non pagato',
    type_88: 'Annullato',
    inputserialNumber: 'Inserisci il numero di serie dell\'apparecchio',
    pickupsuccess: 'Apparecchio ritirato con successo',
    continuepay: 'Continua pagamento'
  },
  borrowSuccess: {
    success: 'Noleggio riuscito',
    renewalTraffic: 'Rinnova traffico',
    viewOrder: 'Vedi ordine',
    HowUseDevice: 'Come usare l\'apparecchio',
    download_tips: 'Puoi lasciare la tua email e ti invieremo i dettagli dell\'ordine',
    download_tips2: 'Per vedere altri punti di restituzione, scarica l\'app.',
    download: 'Scarica',
    loading_title: 'Sblocco power bank',
    loading_tips: 'Attendi...',
    send: 'Invia'
  },
  packageOrder: {
    viewdetail: 'Vedi dettagli',
    buynow: 'Acquista ora',
    isrent: 'L\'apparecchio è noleggiato?',
    timelimited: 'Offerta a tempo limitato'
  },
  packageDetail: {
    WiFiName: 'Nome WiFi',
    WiFiPassword: 'Password WiFi',
    batteryLife: 'Batteria',
    Signal: 'Segnale',
    orderNo: 'N. ordine',
    startingTime: 'Ora inizio',
    endTime: 'Ora fine',
    packageStatus: 'Stato pacchetto',
    usedTraffic: 'Dati usati',
    Renewals: 'Acquista traffico',
    inuse: 'In uso'
  },
  orderDetail: {
    price1: '{pCurrencyName}{pJifei} per {pJifeiDanwei}{priceUnit}',
    price2: 'Fino a {pCurrencyName}{pFengding} per 24 ore',
    price3: 'Fee di mancata restituzione di {pCurrencyName}{overtimeAmount}',
    venuerented: 'Punto di ritiro',
    venuereturned: 'Punto di restituzione',
    timerented: 'Ora di noleggio',
    timereturned: 'Ora di restituzione',
    powerbankid: 'ID Power Bank',
    getreceipt: 'OTTIENI ricevuta',
    buypowerbank: 'Acquista questo power bank',
    usetime: 'Tempo d\'uso',
    estimatedamount: 'Importo stimato',
    feerule: 'Regola tariffaria',
    payment: 'Pagamento',
    orderNo: 'N. ordine',
    trafficDetails: 'Vedi dettagli traffico',
    Renewals: 'Rinnovi',
    FeeSchedule: 'Schema tariffe',
    HowToUse: 'Come usare',
    LeaseMerchant: 'Punto di noleggio',
    startTime: 'Ora inizio',
    ReturningMerchants: 'Punto di restituzione',
    EndTime: 'Ora fine',
    Deposit: 'Cauzione',
    fee1: 'Cauzione apparecchio €500',
    fee2: 'Restituzione entro 7 giorni dalla scadenza: meno €10/giorno/unità.',
    fee3: 'Restituzione entro 7 giorni dalla scadenza: €200/unità verranno detratti.',
    fee4: 'La cauzione viene detratta automaticamente se l\'apparecchio non viene restituito oltre 15 giorni dalla scadenza.',
    rentagain: 'Noleggia di nuovo',
    onrental: 'In noleggio',
    revoked: 'Revocato',
    returned: 'Restituito',
    issue: 'Problema',
    overtimereturn: 'Ritardo'
  },
  pickUp: {
    orderNo: 'N. ordine',
    startingTime: 'Ora inizio',
    endTime: 'Ora fine',
    packageStatus: 'Stato pacchetto',
    confirmationOfPickup: 'Conferma di ritiro'
  },
  aboutus: {
    title: 'Chi siamo',
    desc1: 'BajieCharging è un marchio di soluzioni condivise per power bank di Shenzhen Bajie Charging Technology Co., Ltd. Dal suo stabilimento nel 2018, l\'azienda si concentra sulla ricerca e operazione di dispositivi terminali intelligenti nel campo dell\'economia condivisa. Attraverso l\'innovazione tecnologica continua, sono stati sviluppati vari dispositivi intelligenti.',
    desc2: 'BaJie Charging ha sviluppato un modello di cooperazione OEM maturo. Forniamo le attrezzature e il supporto tecnico, voi gestite il vostro servizio.',
    contactustitle: 'Interessato a diventare partner di ChargeNow? Contattaci——',
    formtitle: 'Hai una domanda? Contattaci!',
    submit: 'Invia',
    name: 'Nome',
    email: 'Email',
    tel: 'Tel',
    nation: 'Nazione',
    message: 'Messaggio'
  },
  contactus: {
    title: 'Contattaci',
    desc1: 'ChargeNow è un marchio di soluzioni di condivisione power bank di Shenzhen Bajie Charging Technology Co., Ltd. ChargeNow opera un servizio di condivisione power bank a livello globale.',
    desc2: 'Se sei interessato a una partnership in franchising, contatta la nostra sede in Cina.',
    contactustitle: 'Sede Cina',
    contactussubtitle: 'Edificio 5, 2°–4° piano, Fuzhong Industrial Park, Huaide Community, Fuyong Subdistrict, Shenzhen CAP: 518128',
    contactusinfotitle: 'Per gli utenti finali che riscontrano problemi, contatta il tuo franchise locale:',
    method1: 'GRANSOL BRASIL',
    methoddesc1: 'Av. Ana Costa, 61 EV 506 Santos/SP CEP 11060-001',
    method2: 'Regione Kazakhstan',
    methoddesc2: 'Città di Aktau'
  },
  rentcost: {
    rentcosttitle: 'Quanto costa il noleggio?',
    price1: '{currency} {jifei} per {jifeiDanwei} {priceUnit}',
    price2: '{currency} {fengding} al giorno',
    tip1: 'Se non restituisci il power bank entro {overtime}, ti verranno addebitati {overtimeAmount} {currency} e non dovrai restituirlo.',
    tip2: 'Un giorno di noleggio = 24 ore dal ritiro.',
    tip3: 'Addebitiamo {yajin} {currency} di cauzione che verrà rimborsata al ritorno.',
    tip4: 'Alcuni punti offrono ore gratuite o sconti. Goditeli!',
    Days: 'Giorni',
    Hours: 'Ore',
    Minutes: 'Minuti',
    free: '{mianfei} minuti gratuiti',
    willcharged: 'Ti verranno addebitati {currency} {money}'
  },
  payment: {
    title: 'Pagamento con carta',
    cardNumber: 'Numero carta',
    cardNumberPlaceholder: 'Inserisci il numero della carta',
    cardHolder: 'Nome del titolare',
    cardHolderPlaceholder: 'Inserisci il nome',
    expiryDate: 'Data di scadenza',
    cvv: 'CVV',
    cvvPlaceholder: 'CVV',
    cardType: 'Tipo di carta',
    selectCardType: 'Seleziona il tipo',
    creditCard: 'Carta di credito',
    debitCard: 'Carta di debito',
    month: 'Mese',
    year: 'Anno',
    payNow: 'Paga ora',
    processing: 'Elaborazione...',
    success: 'Pagamento riuscito',
    failed: 'Pagamento fallito',
    close: 'Chiudi',
    paymentSuccess: 'Pagamento riuscito! Grazie per il tuo acquisto.',
    paymentFailed: 'Pagamento fallito, riprova o usa un altro metodo.',
    networkError: 'Errore di rete, verifica la connessione e riprova.'
  },
  validation: {
    cardNumberRequired: 'Il numero della carta è obbligatorio',
    cardNumberDigitsOnly: 'Il numero deve contenere solo cifre',
    unsupportedCardType: 'Tipo di carta non supportato',
    invalidCardLength: 'Il numero deve avere {lengths} cifre',
    invalidCardNumber: 'Numero carta non valido',
    cardHolderRequired: 'Il nome del titolare è obbligatorio',
    expiryRequired: 'La data di scadenza è obbligatoria',
    cardExpired: 'Carta scaduta',
    cvvRequired: 'Il CVV è obbligatorio',
    cvvDigitsOnly: 'Il CVV deve contenere solo cifre',
    invalidCvvLength: 'Il CVV deve avere {length} cifre',
    cardTypeRequired: 'Il tipo di carta è obbligatorio'
  }
}
